import { useEffect, useRef, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { authApi } from '@/features/auth/api'
import { ApiError } from '@/lib/apiClient'
import { LoadingState, Notice } from '@/components/ui/Feedback'

type VerificationState = 'loading' | 'verified' | 'invalid'

function verificationToken(hash: string) {
  return new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash).get('token')?.trim() ?? ''
}

export default function VerifyEmailPage() {
  const location = useLocation()
  const [state, setState] = useState<VerificationState>('loading')
  const [error, setError] = useState('')
  const requestedToken = useRef('')

  useEffect(() => {
    const token = verificationToken(location.hash)
    if (!token) {
      setState('invalid')
      setError('El enlace de verificación no contiene un código válido.')
      return
    }
    if (requestedToken.current === token) return
    requestedToken.current = token

    authApi.verifyEmail(token)
      .then(() => { if (requestedToken.current === token) setState('verified') })
      .catch((reason: unknown) => {
        if (requestedToken.current !== token) return
        setState('invalid')
        setError(reason instanceof ApiError ? reason.message : 'No pudimos verificar el correo. Inténtalo de nuevo.')
      })
  }, [location.hash])

  if (state === 'loading') return <LoadingState label="Verificando tu correo…" />

  return (
    <section className="auth-page">
      <header className="flow-heading">
        <p className="eyebrow">Cuenta BsPOS</p>
        <h1>{state === 'verified' ? 'Correo verificado' : 'No pudimos verificar el correo'}</h1>
        <p>{state === 'verified' ? 'Tu cuenta ya puede registrar empresas y comprar licencias de software.' : 'El enlace pudo vencer o ya haberse utilizado.'}</p>
      </header>

      {state === 'verified' ? (
        <Notice tone="success">Tu correo está verificado. Ya puedes continuar.</Notice>
      ) : (
        <Notice>{error}</Notice>
      )}

      <p className="flow-footnote"><Link to="/perfil">Ir a mi cuenta</Link></p>
    </section>
  )
}
